<script>
export default {
  name: 'Animator',
  props: {
    event: { required: true },
  },
  data: () => ({
    trigger: 0,
  }),
  created () {
    this.$parent.$on(this.event, () => {
      this.trigger++;
    });
  },
  render (h) {
    const vNode = this.$slots.default[0];
    vNode.key = this.trigger;
    return h('transition', {
      props: this.$attrs,
    }, [vNode]);
  },
};
</script>
